import React, { useEffect, useState } from 'react';
import GaugeChart from 'react-gauge-chart';

const GeneralInformationGraph = ({ loaninfographs }) => {
    const [graphdata, setGraphData] = useState(loaninfographs)
    useEffect(() => {
        setTimeout(() => {
            setGraphData(loaninfographs)
            // setAssetsChart(loaninfographs[0]);
            // setIncomeChart(loaninfographs[1]);
            // setCreditchart(loaninfographs[2]);
            // setCollateralChart(loaninfographs[3]);
            // setOthersChart(loaninfographs[4]);
        }, 3000);
        // console.log(loaninfographs[0]);
    })
    // const [assetschart, setAssetsChart] = useState();
    // const [incomechart, setIncomeChart] = useState();
    // const [creditchart, setCreditchart] = useState();
    // const [collateralchart, setCollateralChart] = useState();
    // const [otherschart, setOthersChart] = useState();
    return (<>
        <div className='row'>
            {/* {staticMasterJson.UIData[0].DecisionDashboardDetails[0].map(graphinformation => ( */}
            {graphdata.map(data => (<div className='col-sm-2'>
                <h6>{data.CN}</h6>
                <GaugeChart id="gauge-chart1"
                    nrOfLevels={4}
                    colors={["#FF2200", "#ff9900", "#ddCc00", "#77FF00"]}
                    arcWidth={0.1}
                    arcPadding={0.03}
                    animate={true}
                    percent={Number(data.PCNTG) / 100}
                    //percent={0.55}
                    needleColor={""}
                    textColor={""}
                />
                <div className='row'>
                    <div className='col-sm-12 text-center'>
                        <p>Evaluated : {data.EV}</p>
                        <p>Cleared   : {data.CLR}</p>
                        <p>Referred  : {data.DEF}</p>
                    </div>
                </div>
            </div>))}
            {/* ))} */}
            {/* <div className='col-sm-2'>
                <h6>Income</h6>
                <GaugeChart id="gauge-chart2"
                    nrOfLevels={4}
                    colors={["#FF2200", "#ff9900", "#ddCc00", "#77FF00"]}
                    arcWidth={0.1}
                    arcPadding={0.03}
                    needleColor={""}
                    animate={true}
                    percent={incomechart.PCNTG}
                    //percent={0.25}
                    textColor={""} />
                <div className='row'>
                    <div className='col-sm-12 text-center'>
                        <p>Evaluated : 2</p>
                        <p>Cleared   : 5</p>
                        <p>Referred  : 7</p>
                    </div>
                </div>
            </div>
            <div className='col-sm-2'>
                <h6>Credit</h6>
                <GaugeChart id="gauge-chart3"
                    nrOfLevels={40}
                    //colors={["#4DA9DE", "#1C2451"]}
                    colors={["#f5df00", "#c9da02", "#77d306", "#4ac407"]}
                    arcWidth={0.1}
                    arcPadding={0.02}
                    needleColor={""}
                    percent={creditchart.PCNTG}
                    //percent={0.25}
                    textColor={""} />
                <div className='row'>
                    <div className='col-sm-12 text-center'>
                        <p>Evaluated : 3</p>
                        <p>Cleared   : 6</p>
                        <p>Referred  : 9</p>
                    </div>
                </div>
            </div>
            <div className='col-sm-2'>
                <h6>Collateral</h6>
                <GaugeChart id="gauge-chart4"
                    nrOfLevels={16}
                    //colors={["#4DA9DE", "#1C2451"]}
                    colors={["#f5df00", "#c9da02", "#77d306", "#4ac407"]}
                    arcWidth={0.1}
                    arcPadding={0.1}
                    needleColor={""}
                    percent={collateralchart.PCNTG}
                    //percent={0.25}
                    textColor={""} />
                <div className='row'>
                    <div className='col-sm-12 text-center'>
                        <p>Evaluated : 2</p>
                        <p>Cleared   : 5</p>
                        <p>Referred  : 8</p>
                    </div>
                </div>
            </div>
            <div className='col-sm-2'>
                <h6>Others</h6>
                <GaugeChart id="gauge-chart5"
                    nrOfLevels={30}
                    colors={["#4DA9DE", "#1C2451"]}
                    //colors={["#f5df00", "#c9da02", "#77d306", "#4ac407"]}
                    arcWidth={0.3}
                    arcPadding={0.05}
                    percent={otherschart.PCNTG}
                    //percent={0.25}
                    needleColor={""}
                    textColor={""} />
                <div className='row'>
                    <div className='col-sm-12 text-center'>
                        <p>Evaluated : 0</p>
                        <p>Cleared   : 0</p>
                        <p>Referred  : 0</p>
                    </div>
                </div>
            </div> */}
        </div>
    </>
    )
}
export default GeneralInformationGraph;